export default __webpack_public_path__ + "static/bbbc-landing-banner-760f5b648fd3d6deb2eb38334ddc88ca.webp";